import React, { useState } from 'react';
import { StyleSheet, View, Text, LayoutChangeEvent } from 'react-native';
import { getColors } from '../../constants/colors';
import { textStyles } from '../../constants/textStyles';
import { ErrorImageFor404 } from '../../resources/svgComponents/ErrorImageFor404';
import { UniversalProps } from '../../typesAndInterfaces/componentProps';
import { MB_Button } from '@mightybyte/rnw.components.button';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';

const NotFound = ({ navigation }: UniversalProps) => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    const viewWidthChanged = (event: LayoutChangeEvent) => {
        const width = event.nativeEvent.layout.width;
        if (width < 585 && !isSmallScreen) {
            setIsSmallScreen(true);
        } else if (width >= 585 && isSmallScreen) {
            setIsSmallScreen(false);
        }
    };

    return (
        <View style={styles.container} onLayout={viewWidthChanged}>
            <View style={styles.innerContainer}>
                <ErrorImageFor404 size={isSmallScreen ? 300 : undefined} />
                <Text style={styles.notFoundText}>
                    We can't seem to find the page{'\n'}you're looking for.
                </Text>

                <MB_Button
                    title="Back to Home"
                    style={styles.backToHomeButton}
                    onPress={() => {
                        navigation.reset({
                            index: 0,
                            routes: [{ name: navigation.getState().routeNames[0] }],
                        });
                    }}
                />
            </View>
        </View>
    );
};

export { NotFound };

const COLORS = getColors();

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLORS.backgroundPrimary,
        alignItems: 'center',
        padding: 32,
    },
    innerContainer: {
        top: '20%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    notFoundText: mbTextStyles([
        textStyles.normalText, {
            fontSize: 20,
            marginTop: 53,
        },
    ]),
    backToHomeButton: {
        width: 268,
        height: 63,
        marginTop: 23,
        backgroundColor: COLORS.buttonPrimaryBg,
    },
});
